// The screen's four modals in one place: schema details, archive, cache clear and
// the removed-attributes confirmation.

import React from 'react';
import PropTypes from 'prop-types';

import SchemaDetailsModal from '../../../components/SchemaDetailsModal';
import ArchiveModal from '../ArchiveModal';
import CacheModal from '../CacheModal';
import RemoveLocationAttributesModal from '../RemoveLocationAttributesModal';

const SettingsModals = ({
  integrationName = '',
  schema,
  archive,
  cacheJob,
  removal,
}) => (
  <>
    <SchemaDetailsModal
      content={schema.content}
      visibility={schema.visible}
      handleVisibility={schema.setVisible}
    />
    <ArchiveModal
      visible={archive.visible}
      loading={archive.archiving}
      integrationName={integrationName}
      ssToDelete={archive.toDelete}
      ssToUpdate={archive.toUpdate}
      onArchive={archive.archive}
      onClose={archive.close}
    />
    <CacheModal
      visible={cacheJob.visible}
      loading={cacheJob.running}
      onClear={cacheJob.start}
      onClose={cacheJob.toggle}
    />
    <RemoveLocationAttributesModal
      visible={removal.confirmVisible}
      removedNames={removal.removedNames}
      onConfirm={removal.confirmRemoval}
      onClose={removal.cancelRemoval}
    />
  </>
);

SettingsModals.propTypes = {
  integrationName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  schema: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  archive: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cacheJob: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  removal: PropTypes.object.isRequired,
};
export default SettingsModals;
